
<div class="card">
  <div class="card-header">
    <div class="d-flex justify-content-between align-items-center">
      <div class="card-title">
        Failed User Logins
      </div>

      <button
        type="button"
        title="Refresh List"
        class="btn btn-primary btn-round"
        (click)="getFailedLogins()"
        data-testid="failed-logins-refresh-list">
        <i class="fa-solid fa-rotate-right"></i>
      </button>
    </div>
  </div>

  <div class="card-body p-0">
    <ngx-datatable
      #table
      class="material striped login-table-height"
      [rows]="failedLogins"
      [loadingIndicator]="isLoading"
      [columnMode]="columnMode.force"
      [headerHeight]="40"
      [footerHeight]="40"
      [rowHeight]="45"
      [scrollbarV]="true"
    >

      <!-- UserId -->
      <ngx-datatable-column
        cellClass="text-left"
        headerClass="text-left"
        name="Id"
        prop="userId"
        [width]="60"
      >
        <ng-template ngx-datatable-cell-template let-userId="value" let-row="row" let-rowIndex="rowIndex">
          <div class="user-id">
            <div
              [title]="userId"
            >
              ...{{userId.slice(-8)}}
            </div>

            <div
              title="Copy User ID to clipboard"
              class="copy-to-clipboard fa-regular fa-clipboard"
              (click)="copyToClipboard(row)"
              role="button"
              [attr.data-testid]="'failed-logins-copy-user-id-to-' + rowIndex">
              <!-- <div class="fa-regular fa-clipboard"></div> -->
            </div>
          </div>
        </ng-template>
      </ngx-datatable-column>

      <!-- Email -->
      <ngx-datatable-column
        cellClass="text-left"
        headerClass="text-left"
        name="Email"
        prop="email"
        [width]="125"
        [sortable]="true"
      >
        <ng-template ngx-datatable-cell-template let-email="value">
          <div class="d-flex align-items-center">
            <div>{{email}}</div>

          </div>
        </ng-template>
      </ngx-datatable-column>

      <!-- Is Locked Out -->
      <ngx-datatable-column
        cellClass="text-center"
        headerClass="text-center"
        name="Locked Out"
        prop="isLockedOut"
        [width]="40"
        [sortable]="true"
      >
        <ng-template ngx-datatable-cell-template let-isLockedOut="value" let-row="row">
          <i *ngIf="isLockedOut" class="fa fa-lock"></i>
        </ng-template>
      </ngx-datatable-column>

       <!-- LockoutEnd -->
      <ngx-datatable-column
        cellClass="text-center"
        headerClass="text-center"
        name="Lockout Expiration"
        prop="lockoutEnd"
        [width]="80"
      >
        <ng-template ngx-datatable-cell-template let-row="row">
          <div>{{ getLocalLockoutEnd(row) }}</div>
        </ng-template>
      </ngx-datatable-column>

      <!-- AccessFailedCount -->
      <ngx-datatable-column
        cellClass="text-center"
        headerClass="text-center"
        name="Failed Logins"
        prop="accessFailedCount"
        [width]="70"
        >
        <ng-template ngx-datatable-cell-template let-failedLoginCount="value">
          <div>{{ failedLoginCount }}</div>
        </ng-template>
      </ngx-datatable-column>

      <!-- Actions -->
      <ngx-datatable-column
        name="Actions"
        headerClass="text-right"
        cellClass="text-right"
        [width]="60"
      >
        <ng-template ngx-datatable-cell-template let-row="row" let-rowIndex="rowIndex">
          <div class="d-flex justify-content-end">
            <button
              *ngIf="isLockedOut(row)"
              type="button"
              class="btn btn-primary btn-sm"
              (click)="removeLockout(row)"
              title="Remove Lockout"
              [attr.data-testid]="'failed-logins-remove-lockout-' + rowIndex">
              <i class="fa-solid fa-lock-open"></i>
              <span>Remove Lockout</span>
            </button>

            <button
              *ngIf="!isLockedOut(row)"
              type="button"
              class="btn btn-danger btn-sm"
              (click)="lockoutUser(row)"
              title="Lock Out User"
              [attr.data-testid]="'failed-logins-lock-out-user-' + rowIndex">
              <i class="fa-solid fa-lock"></i>
              <span>Lock Out User</span>
            </button>
          </div>
        </ng-template>
      </ngx-datatable-column>
    </ngx-datatable>
  </div>

</div>





// WEBPACK FOOTER //
// ./src/app/developer/auth-tools/failed-logins/failed-logins.component.html